<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" :title="dialogTitle" width="1200px" top="4vh" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close='true'>
    <div class="content">
      <embed class="embed" :src="fileURL" type="application/pdf">
      <!-- <el-empty class="empty" :image-size="200" v-else description="暂无报告"></el-empty> -->
      <!-- <embed class="embed" :src="pdfBase64" type="application/pdf"> -->
      <!-- <iframe :src="fileURL" frameborder="0" width="100%" height="100%"></iframe> -->
    </div>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">通 过</el-button>
      <el-button class="close" :size="size" @click="handleRejected()">驳 回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  name: 'addOrUpdate',
  props: {
    dialogTitle: {
      type: String,
      default: '审核'
    },
    isRedispatch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pdfBase64: '',
      size: 'small',
      dialogLoading: false,
      visible: false,
      dataForm: {
        orderId: 0
      },
      isAudit: false,
      blobData: '',
      fileURL: ''
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init (row, isAudit) {
      this.visible = true
      this.isAudit = false
      this.pdfBase64 = ''
      this.$nextTick(() => {
        if (isAudit) {
          this.isAudit = isAudit
        }
        this.dataForm = Object.assign({}, row)
        this.handleGetInfo()
      })
      // Promise.all([]).then(() => {
      //   if (this.dataForm.id) {
      //     this.handleGetInfo()
      //   }
      // })
    },
    handleGetInfo () {
      this.$api.file.pullCompanySmallFile(this.dataForm.reportFileResourceId).then((res) => {
        if (res.success) {
          this.pdfBase64 = res.data?.data
          // let mime = pdfBase64.match(/:(.*);/)[1]
          let mime = 'application/pdf;chartset=UTF-8'
          let bstr = window.atob(this.pdfBase64)
          let n = bstr.length
          let u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          this.blobData = new Blob([u8arr], { type: mime })
          this.fileURL = URL.createObjectURL(this.blobData)
        }
      })
    },
    submitHandle:debounce (function () {
      this.dialogLoading = true
      const workOrderId = this.dataForm.workOrderId ? this.dataForm.workOrderId : this.dataForm.id
      let toStatus = 0
      if (this.dataForm.status && this.dataForm.status === 10) {
        toStatus = 6
      } else {
        toStatus = 7
      }
      this.$api.electricOperations.changeElectricOperationsWorkOrderState(
        workOrderId,
        toStatus,
        ''
      ).then((res) => {
        this.dialogLoading = false
        if (res.success) {
          this.visible = false
          this.$message.success('操作成功')
          this.$emit('handleQuery')
        }
      })
    }, 1000, { 'leading': true, 'trailing': false } ),
    handleRejected:debounce (function () {
      this.$emit('handleRejected', '', this.dataForm)
    }, 1000, { 'leading': true, 'trailing': false } ),
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 620px;
  .embed {
    width: 100%;
    height: 100%;
  }
  .empty {
    width: 100%;
    height: 100%;
  }
}
</style>
